(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function scrollThumbIntoView(thumbsSwiper, index) {
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

    const slide = thumbsSwiper.slides[index];
    if (!slide) return;

    const slideLeft = slide.offsetLeft;
    const slideWidth = slide.offsetWidth;
    const viewWidth = thumbsSwiper.width;
    const maxTranslate = 0;
    const minTranslate = Math.min(0, viewWidth - thumbsSwiper.wrapperEl.scrollWidth);

    let translate = viewWidth / 2 - slideLeft - slideWidth / 2;
    translate = clamp(translate, minTranslate, maxTranslate);

    thumbsSwiper.setTransition(300);
    thumbsSwiper.setTranslate(translate);
    thumbsSwiper.updateActiveIndex();
    thumbsSwiper.updateSlidesClasses();
  }

  function fixPdpMediaGallery(root) {
    const swiperComponent = root.querySelector('swiper-component');
    if (!swiperComponent) return;

    const mainEl = swiperComponent.querySelector('.swiper-main');
    const thumbEl = swiperComponent.querySelector('.swiper-controls__thumbnails');

    const tryFix = (attemptsLeft) => {
      const mainSwiper = mainEl?.swiper;
      const thumbsSwiper = thumbEl?.swiper;

      if (!mainSwiper || !thumbsSwiper) {
        if (attemptsLeft > 0) {
          setTimeout(() => tryFix(attemptsLeft - 1), 150);
        }
        return;
      }

      if (swiperComponent.dataset.pdpMediaFixed === 'true') return;
      swiperComponent.dataset.pdpMediaFixed = 'true';

      if (thumbsSwiper.params.loop) {
        thumbsSwiper.loopDestroy();
        thumbsSwiper.params.loop = false;
      }

      thumbsSwiper.params.slidesPerView = 'auto';
      thumbsSwiper.params.slidesPerGroup = 1;
      thumbsSwiper.params.freeMode = false;
      thumbsSwiper.params.watchSlidesProgress = true;
      thumbsSwiper.params.slideToClickedSlide = true;
      thumbsSwiper.update();

      const syncThumbs = () => {
        scrollThumbIntoView(thumbsSwiper, mainSwiper.realIndex);
      };

      mainSwiper.on('slideChange', syncThumbs);
      syncThumbs();
    };

    tryFix(40);
  }

  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
  const stickyInstances = new Set();
  let stickyScheduled = false;

  function getStickyHeaderOffset() {
    const bodyHeader = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    if (!Number.isNaN(bodyHeader) && bodyHeader > 0) return bodyHeader + 16;

    const header = document.querySelector('.header-section, .header');
    return header ? header.getBoundingClientRect().height + 16 : 24;
  }

  function findStickyStopElement(productInfo) {
    const details = productInfo.querySelector('.product-details, .product-pdp-details--cream');
    if (!details) return null;

    return (
      details.querySelector('.payment-icons') ||
      details.querySelector('.payment-icons__list') ||
      details.querySelector('.buy-buttons-block') ||
      details.querySelector('.product-form__buttons')
    );
  }

  function updateStickyBoundary(productInfo) {
    const mediaCol = productInfo.querySelector('.product-information__media');
    const media = mediaCol?.querySelector('.product-pdp-media');
    const stopEl = findStickyStopElement(productInfo);

    if (!mediaCol || !media) return;

    if (!DESKTOP_MQ.matches) {
      mediaCol.style.removeProperty('top');
      return;
    }

    const headerOffset = getStickyHeaderOffset();
    mediaCol.style.top = `${headerOffset}px`;

    if (!stopEl) return;

    const mediaRect = media.getBoundingClientRect();
    const stopRect = stopEl.getBoundingClientRect();
    const overflow = mediaRect.bottom - stopRect.bottom;

    if (overflow > 0) {
      mediaCol.style.top = `${headerOffset - overflow}px`;
    }
  }

  function scheduleStickyUpdate() {
    if (stickyScheduled) return;
    stickyScheduled = true;
    requestAnimationFrame(() => {
      stickyInstances.forEach((productInfo) => updateStickyBoundary(productInfo));
      stickyScheduled = false;
    });
  }

  function initStickyMedia() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (!productInfo.querySelector('.product-pdp-media')) return;
      stickyInstances.add(productInfo);
      updateStickyBoundary(productInfo);

      if (window.__pdpMediaStickyResizeObserver) {
        const details = productInfo.querySelector('.product-details, .product-pdp-details--cream');
        const media = productInfo.querySelector('.product-pdp-media');
        if (details) window.__pdpMediaStickyResizeObserver.observe(details);
        if (media) window.__pdpMediaStickyResizeObserver.observe(media);
      }
    });
  }

  function init() {
    document.querySelectorAll('.product-pdp-media').forEach((root) => {
      const swiperComponent = root.querySelector('swiper-component');
      if (swiperComponent) {
        delete swiperComponent.dataset.pdpMediaFixed;
      }
      fixPdpMediaGallery(root);
    });

    initStickyMedia();
    scheduleStickyUpdate();
  }

  if (!window.__pdpMediaStickyListenersBound) {
    window.__pdpMediaStickyListenersBound = true;
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate);
    DESKTOP_MQ.addEventListener('change', scheduleStickyUpdate);
    document.addEventListener('variant:update', scheduleStickyUpdate);
  }

  if (typeof ResizeObserver !== 'undefined' && !window.__pdpMediaStickyResizeObserver) {
    window.__pdpMediaStickyResizeObserver = new ResizeObserver(scheduleStickyUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', init);
})();
